import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main-page',
      component: require('@/components/MainPage').default,
    },
    {
      path: '/BEFORE',
      name: 'before-order-page',
      component: require('@/components/BeforeOrderPage').default,
    },
    {
      path: '/ORDER',
      name: 'order-page',
      component: require('@/components/OrderPage').default,
    },
    {
      path: '/DELIVERY',
      name: 'delivery-page',
      component: require('@/components/DeliveryPage').default,
    },
    {
      path: '/PAYMENT',
      name: 'payment-page',
      component: require('@/components/PaymentPage').default,
    },
    {
      path: '/INVOICE',
      name: 'invoice-page',
      component: require('@/components/InvoicePage').default,
    },
    {
      path: '/UPLOAD',
      name: 'upload-page',
      component: require('@/components/UploadPage').default,
    },
    {
      path: '/DONE',
      name: 'done-page',
      component: require('@/components/DonePage').default,
    },
    {
      path: '/INVALID',
      name: 'invalid-page',
      component: require('@/components/InvalidPage').default,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
